import React from 'react';

import { showDateNoTime } from '@libs/NwMoment';

import AddressLine from '@components/Addresses/AddressLine';
import { EventDetailsWrapper } from '@components/EventDrawer/EventDrawerUi/EventUI';
import FlexContainer from '@components/Gui/FlexContainer';
import NwEllipsis from '@components/Gui/NwEllipsis';
import NwIcon from '@components/Gui/NwIcon';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AccommodationDetails = ({ type, accommodationData }) => {
    return (
        <EventDetailsWrapper>
            <ResponsiveFlexContainer
                columns={[
                    {
                        content: (
                            <div className="is-icon">
                                <NwIcon
                                    icon={
                                        type === 'RoomLodging'
                                            ? byPrefixAndName.fasl['house-user']
                                            : byPrefixAndName.fasl['bed']
                                    }
                                />
                            </div>
                        ),
                        isBorder: true,
                        width: '30%',
                    },
                    {
                        content: (
                            <>
                                {accommodationData.Service && accommodationData.Service.Name && (
                                    <div className="is-content is-stronger big">{accommodationData.Service.Name}</div>
                                )}
                                <div className="address-container">
                                    <AddressLine address={accommodationData} twoLines noIcon />
                                </div>
                                <FlexContainer mg="8px 0 0">
                                    <div>
                                        <div className="is-label">CHECK IN</div>
                                        <div className="is-content date-time">
                                            {showDateNoTime(accommodationData.FromDate)}
                                        </div>
                                    </div>
                                    <NwIcon className="arrow-icon" icon={byPrefixAndName.fasl['arrow-right']} />
                                    <div>
                                        <div className="is-label">Check Out</div>
                                        <div className="is-content date-time">
                                            {showDateNoTime(accommodationData.ToDate)}
                                        </div>
                                    </div>
                                </FlexContainer>
                            </>
                        ),
                        isBorder: false,
                    },
                ]}
            />
            {!accommodationData.GroupGuid && (
                <>
                    <ResponsiveFlexContainer
                        columns={[
                            {
                                content: <p className="is-label">Reservation Code</p>,
                                isLabel: true,
                                isBorder: true,
                                width: '30%',
                            },
                            {
                                content: <p className="is-content">{accommodationData.ReservationCode}</p>,
                                isContent: true,
                                isBorder: false,
                            },
                        ]}
                    />
                    <ResponsiveFlexContainer
                        columns={[
                            {
                                content: <p className="is-label">Note</p>,
                                isBorder: true,
                                width: '30%',
                            },
                            {
                                content: (
                                    <div className="is-content">
                                        <NwEllipsis rows={3} text={accommodationData.Note} />
                                    </div>
                                ),
                                isBorder: false,
                            },
                        ]}
                    />
                </>
            )}
        </EventDetailsWrapper>
    );
};

export default AccommodationDetails;
